import { render, staticRenderFns } from "./OmsLegend.vue?vue&type=template&id=288b4ef2&scoped=true"
import script from "./OmsLegend.vue?vue&type=script&lang=js"
export * from "./OmsLegend.vue?vue&type=script&lang=js"
import style0 from "./OmsLegend.vue?vue&type=style&index=0&id=288b4ef2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288b4ef2",
  null
  
)

export default component.exports